// extracted by mini-css-extract-plugin
export var img = "k_C";
export var link = "k_B";
export var placeholder = "k_D";
export var title = "k_y";